import 'core-js/fn/string/includes';
import 'core-js/fn/string/trim';
import 'core-js/fn/array/find';
import 'core-js/es6/object';
import 'core-js/fn/object/values';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/fn/array/includes';
import 'core-js/fn/array/for-each';
import 'core-js/fn/string/virtual/starts-with';
